module.exports = __webpack_public_path__ + "media/4x3/gl-2490aa08.svg";